import { graphql } from 'gatsby';
import React from 'react';

import { BikeRouteQuery } from '../../../../graphql-types';
import { TPageProps } from '../../../page-props';
import BikeRouteDetailsPage from '../../../templates/bike-route-details';

export default (props: TPageProps<BikeRouteQuery>) => <BikeRouteDetailsPage {...props} />;

export const query = graphql`
  query BikeRoute($id: Int, $rideIds: [Int], $withQuery: Boolean!) {
    bikeRoute(originalId: { eq: $id }) @include(if: $withQuery) {
      data {
        ...BikeRouteData
      }
    }
    bikeRouteRides: allRide(filter: { originalId: { in: $rideIds } }) @include(if: $withQuery) {
      nodes {
        data {
          ...BikeRouteRideData
        }
      }
    }
  }
`;
